var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("p", [
      +_vm.drug.pack_set > 1
        ? _c("span", { staticClass: "badge badge-dark" }, [
            _vm._v("комплект (" + _vm._s(+_vm.drug.pack_set) + " зав.уп.)"),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    +_vm.drug.pack_set > 1
      ? _c("p", [
          _vm._v("Комплект "),
          _c("span", { staticClass: "actual_drug_price" }, [
            _vm._v(_vm._s(_vm.actualPrice * +_vm.drug.pack_set)),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex flex_gap_5" },
      [
        _c("span", { class: { "fs-12": +_vm.drug.pack_set > 1 } }, [
          _vm._v("Стоимость "),
          _c("span", { staticClass: "actual_drug_price" }, [
            _vm._v(_vm._s(_vm.actualPrice)),
          ]),
        ]),
        _vm._v(" "),
        _vm.discount
          ? _c("span", { staticClass: "badge badge-danger" }, [
              _vm._v("Скидка"),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showCoolCondition
          ? [_c("DiscountInfoBlock", { attrs: { drug: _vm.drug } })]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _vm.priceDisabled
      ? _c("div", [
          _c("span", { staticClass: "badge badge-warning" }, [
            _vm._v("не активен на сайте!"),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$AllDivisions[_vm.divId]?.settings?.currency_id
      ? _c("p", [
          _c("strong", [
            _vm._v(
              _vm._s(
                _vm.$AllCurrencies[
                  _vm.$AllDivisions[_vm.divId]?.settings?.currency_id
                ].currency
              )
            ),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "actual_drug_price" }, [
            _vm._v(_vm._s(_vm.drug.currency_price)),
          ]),
          _vm._v(" "),
          _vm.discount
            ? _c("span", { staticClass: "badge badge-danger" }, [
                _vm._v("Скидка"),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.drug.lgot_price
      ? _c("p", { staticClass: "badge badge-info" }, [
          _vm._v("Льготная доставка"),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.priceForActualization
      ? _c(
          "button",
          {
            staticClass: "btn btn-outline-warning btn-xs",
            on: { click: _vm.updatePriceToActual },
          },
          [_vm._v("\n    Актуализировать цену\n  ")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }